import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AlertComponent, CardSelectComponent, ITagImage, ModalComponent } from '@tecalisdev/infinity';
import {
	autofillToFormOcrOrderChoice,
	FormOcrOrderChoice,
	formOcrOrderChoiceToAutofill,
} from '../../utils/form-ocr-autofill.util';

export type FormOcrOrderModalMode = 'continue' | 'edit';

export type FormOcrOrderModalClose =
	| { action: 'confirm'; autofillFromOcr: boolean }
	| { action: 'editForm' }
	| { action: 'dismiss' };

/**
 * Modal NIF-657: Autocompletar vs Introducir manualmente.
 * Figma `12344:321119` (Guardar) / Continuar OCR.
 * Layout DS: `tec-modal` + `tagImage` + `tec-alert` + `body__text` + `grid grid-i2` + `tec-card-select`
 * (mismo patrón que `modal-design-theme` / `modal-block-identity`).
 */
@Component({
	selector: 'app-modal-workflow-form-ocr-order',
	imports: [ReactiveFormsModule, TranslatePipe, ModalComponent, AlertComponent, CardSelectComponent],
	templateUrl: './modal-workflow-form-ocr-order.component.html',
	styleUrl: './modal-workflow-form-ocr-order.component.scss',
})
export class ModalWorkflowFormOcrOrderComponent implements OnInit {
	@Input() mode: FormOcrOrderModalMode = 'continue';
	/** Preferencia actual (`true` = documento, `false` = manual, `null` = sin elegir). */
	@Input() autofillFromOcr: boolean | null = null;
	@Output() closeEvent = new EventEmitter<FormOcrOrderModalClose>();

	/** Icono cabecera modal (Figma tag-img `icon-fill-form`). */
	public readonly modalTagImage: ITagImage = { icon: 'icon-fill-form' };

	public readonly form = new FormGroup({
		choice: new FormControl<FormOcrOrderChoice | null>(null, Validators.required),
	});

	ngOnInit(): void {
		const initial = autofillToFormOcrOrderChoice(this.autofillFromOcr);
		if (initial) {
			this.form.get('choice')?.setValue(initial);
		}
	}

	public get isContinueMode(): boolean {
		return this.mode === 'continue';
	}

	public get primaryLabelKey(): string {
		return this.isContinueMode ? 'BUTTON.CONTINUE' : 'BUTTON.SAVE';
	}

	public isChoiceSelected(choice: FormOcrOrderChoice): boolean {
		return this.form.get('choice')?.value === choice;
	}

	public selectChoice(choice: FormOcrOrderChoice, selected = true): void {
		if (!selected) {
			return;
		}
		this.form.get('choice')?.setValue(choice);
		this.form.get('choice')?.markAsTouched();
	}

	public closeModal(type: string): void {
		if (type === 'buttonPrimary') {
			if (this.form.invalid) {
				this.form.markAllAsTouched();
				return;
			}
			const choice = this.form.get('choice')?.value as FormOcrOrderChoice;
			this.closeEvent.emit({
				action: 'confirm',
				autofillFromOcr: formOcrOrderChoiceToAutofill(choice),
			});
			return;
		}
		if (type === 'buttonSecondary' && this.isContinueMode) {
			this.closeEvent.emit({ action: 'editForm' });
			return;
		}
		this.closeEvent.emit({ action: 'dismiss' });
	}
}
